import { EmptyObject } from '../../EmptyObject';

export type ManagementSecurityRequests =
	| ManagementSecurityGetPinCodeRequest
	| ManagementSecuritySetPinCodeRequest
	| ManagementSecurityGenerateRandomPinCodeRequest;

export const ManagementSecurityGetPinCodeRequest = 'sos.Monitoring.Management.ManagementSecurityGetPinCodeRequest';
export interface ManagementSecurityGetPinCodeRequest {
	type: typeof ManagementSecurityGetPinCodeRequest;
}

export const ManagementSecurityGetPinCodeResult = 'sos.Monitoring.Management.ManagementSecurityGetPinCodeResult';
export interface ManagementSecurityGetPinCodeResult {
	type: typeof ManagementSecurityGetPinCodeResult;
	pinCode: string;
}

export const ManagementSecuritySetPinCodeRequest = 'sos.Monitoring.Management.ManagementSecuritySetPinCodeRequest';
export interface ManagementSecuritySetPinCodeRequest {
	type: typeof ManagementSecuritySetPinCodeRequest;
	pinCode: string;
}

export const ManagementSecuritySetPinCodeResult = 'sos.Monitoring.Management.ManagementSecuritySetPinCodeResult';
export interface ManagementSecuritySetPinCodeResult {
	type: typeof ManagementSecuritySetPinCodeResult;
	result: EmptyObject;
}

export const ManagementSecurityGenerateRandomPinCodeRequest = 'sos.Monitoring.Management.ManagementSecurityGenerateRandomPinCodeRequest';
export interface ManagementSecurityGenerateRandomPinCodeRequest {
	type: typeof ManagementSecurityGenerateRandomPinCodeRequest;
}

export const ManagementSecurityGenerateRandomPinCodeResult = 'sos.Monitoring.Management.ManagementSecurityGenerateRandomPinCodeResult';
export interface ManagementSecurityGenerateRandomPinCodeResult {
	type: typeof ManagementSecurityGenerateRandomPinCodeResult;
	result: EmptyObject;
}
